module.exports = __webpack_public_path__ + "img/godeeper.04669598.png";